import { ENVS } from "../constants";

function normalizeTenantPortalBase(url: string): string {
  return url.replace(/\/+$/, "");
}

/**
 * Absolute URL into the tenant app (destination path only—no `/signup` prefix).
 * Unauthenticated visitors are redirected by the app to sign-in with `returnUrl`.
 */
export function buildTenantPortalInviteUrl(returnPath: string): string {
  const base = normalizeTenantPortalBase(ENVS.tenant_portal_url || "");
  if (!base) {
    return "";
  }
  const path = returnPath.startsWith("/") ? returnPath : `/${returnPath}`;
  return `${base}${path}`;
}

export function tenantInviteReturnPathForProperty(propertyId: string): string {
  return `/unit?propertyId=${encodeURIComponent(propertyId)}`;
}

export function tenantInviteReturnPathForUnit(unitId: string): string {
  return `/lease-application/Unit/${encodeURIComponent(unitId)}`;
}

/** Tenant app: review shadow invite + link flow (requires sign-in; server matches email to shadow). */
export function buildTenantShadowInviteUrl(
  shadowTenantId: string,
  context: { leaseId: string } | { stayId: string } | string,
): string {
  const base = normalizeTenantPortalBase(ENVS.tenant_portal_url || "");
  if (!base) {
    return "";
  }
  const params = new URLSearchParams({ shadowTenantId });
  if (typeof context === "string") {
    params.set("leaseId", context);
    params.set("contextType", "lease");
    params.set("contextId", context);
  } else if ("stayId" in context) {
    params.set("contextType", "stay");
    params.set("contextId", context.stayId);
  } else {
    params.set("leaseId", context.leaseId);
    params.set("contextType", "lease");
    params.set("contextId", context.leaseId);
  }
  return `${base}/shadow-invite?${params.toString()}`;
}
